import React, { Component } from 'react';
import QueryHeader from '../../components/header/header';
import DocumentTitle from 'react-document-title';
import queryString from 'query-string';
import './overview.less';
import API from '../../../../api/api';
import TimeInterval from '../../components/timeInterval/timeInterval';
class OverView extends Component {
    constructor(props) {
        super(props);
        this.chooseDateRange = this.chooseDateRange.bind(this);
        this.clearTime = this.clearTime.bind(this);
        this.searchResult = this.searchResult.bind(this);
    }
    state = {
        companyId: '',
        companyCode: '',
        startTime: '',
        endTime: '',
        roleName: '',
        dataList: [],
        allWriteOffCount: '',// 总计核销数
        allAbNormalCount: '',// 风控异常数
        allWriteOffMoney: '',//总计金额
        allAbNormalMoney: '',//风控异常金额
    }
    clickNum(id,isSafe) {
        const { companyCode } = this.state;
        let url='/query/detail?id=' + id + '&companyCode=' + companyCode;
        if(isSafe||isSafe==0)
            url=url+'&isSafe='+isSafe;
        this.props.history.push(url);
    }
    clearTime() {
        this.setState({ startTime: '', endTime: '' })
        const {param} = this.state;
        delete(param.startTime);
        delete(param.endTime);
        this.setState({param:param});
    }
    clickCompany(id, roleName) {
        const {  companyCode} = this.state;  
        let url=window.location.origin+'/crm/query/overview?id=' + id  + '&roleName=' + roleName + '&companyCode=' + companyCode;
        window.location.href=url
    }
    componentDidMount() {
        let urlData = queryString.parse(window.location.search);
        let param = {
            companyCode: urlData.companyCode,
            queryCompany: urlData.id?urlData.id:urlData.companyCode
        }
        if (urlData) {
            this.setState({
                param: param,
                companyCode: urlData.companyCode,
                companyId: urlData.id ? urlData.id : urlData.companyCode,
                roleName:urlData.roleName ? urlData.roleName:''
            })
        }
        this.getDataList(param);
    }
    chooseDateRange(value) {
        this.setState({ startTime: value.startTime, endTime: value.endTime });
    }
    searchResult() {
        const { companyId,
            companyCode,
            param,
            startTime,
            endTime 
        } = this.state
        if (startTime && endTime) {
            param.startTime = startTime;
            param.endTime = endTime
        }
        this.getDataList(param);
        return;
    }
    getDataList = async (param) => {
        let result = await API.getOverviewList(param);
        if (!result) return;
        if (result.status == 1) {
            if (result.data.consumeCountVOList) {
                this.setState({
                    dataList: result.data.consumeCountVOList, 
                    allWriteOffCount: result.data.totalConsumeCountVO.consumeNum,
                    allAbNormalCount: result.data.totalConsumeCountVO.riskNum,
                    allWriteOffMoney:result.data.totalConsumeCountVO.consumeAmount,
                    allAbNormalMoney:result.data.totalConsumeCountVO.riskAmount,
                });
            }
        }
    }
    render() {
        const {
            companyId, dataList, allWriteOffCount, allAbNormalCount, roleName,
            allWriteOffMoney,allAbNormalMoney
        } = this.state;
        return (
            <DocumentTitle title="铛铛合作方核销查询系统">
                <div className="mainOverviewPane">
                    <div className="dateChoose">
                        <TimeInterval className="timePicker" confirmCallback={this.chooseDateRange} clearTime={this.clearTime}></TimeInterval>
                        <div className="btnSearch" onClick={this.searchResult}>搜索</div>
                    </div>
                    <table className="tableBlock">
                        <tbody>
                            <tr>
                                <th>{companyId.indexOf('F')==0 ? '所属公司':'门店名称'}</th>
                                <th>总计核销数</th>
                                <th>总计金额（元）</th>
                                <th>风控异常数</th>
                                <th>风控异常金额（元）</th>
                            </tr>
                            {
                                dataList ?
                                    dataList.map((item, index) => {
                                        return <tr key={index}>
                                            {
                                                companyId.indexOf('F')==0  ? <td><a onClick={this.clickCompany.bind(this, item.countObjCode, item.countObjName)}>{item.countObjName}</a></td> : <td>{item.countObjName}</td>
                                            }
                                            <td><a onClick={this.clickNum.bind(this, item.countObjCode,0)}>{item.consumeNum}</a></td>
                                            <td><a onClick={this.clickNum.bind(this, item.countObjCode,0)}>{item.consumeAmount/100}</a></td>
                                            <td><a onClick={this.clickNum.bind(this, item.countObjCode,2)}>{item.riskNum}</a></td>
                                            <td><a onClick={this.clickNum.bind(this, item.countObjCode,2)}>{item.riskAmount/100}</a></td>
                                        </tr>
                                    })
                                    : ''
                            }
                            <tr>
                                <td>合计</td>
                                <td><a onClick={this.clickNum.bind(this, companyId,0)}>{allWriteOffCount}</a></td>
                                <td><a onClick={this.clickNum.bind(this, companyId,0)}>{allWriteOffMoney/100}</a></td>
                                <td><a onClick={this.clickNum.bind(this, companyId,2)}>{allAbNormalCount}</a></td>
                                <td><a onClick={this.clickNum.bind(this, companyId,2)}>{allAbNormalMoney/100}</a></td>
                            </tr>
                        </tbody>
                    </table>
                    <QueryHeader roleName={'“铛铛合作方”核销查询系统 - '+roleName} systemColor='#4574F4'></QueryHeader>
                </div>
            </DocumentTitle>
        )
    }
}
export default OverView;